<template>
  <div class="main-wrapper">
    <HalamanAwal/>
  </div>
</template>

<script>
import HalamanAwal from './beranda/HalamanAwal'
export default {
  name: "Home",
  components: {
    HalamanAwal,
  },
};
</script>
